import { ChangePasswordViaOtpDialogComponent } from './../../shared/components/change-password-via-otp-dialog/change-password-via-otp-dialog.component';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app-services/auth-service/auth.service';
import { User } from '@app-models/user.model';
import { UserService } from '@app-services/user/user.service';
import { BoardsDialogComponent } from '@app-shared/components/boards-dialog/boards-dialog.component';
import { ChangePasswordDialogComponent } from '@app-shared/components/change-password-dialog/change-password-dialog.component';
import { ConfirmDeleteImageDialogComponent } from '@app-shared/components/confirm-delete-image-dialog/confirm-delete-image-dialog.component';
import { EditPhoneNumberDialogComponent } from '@app-shared/components/edit-phone-number-dialog/edit-phone-number-dialog.component';
import { ExamDialogComponent } from '@app-shared/components/exam-dialog/exam-dialog.component';
import { GradesdialogComponent } from '@app-shared/components/gradesdialog/gradesdialog.component';
import { TestlistService } from '@app-services/test/testlist.service';
import { ConfirmEditPhoneNumberDialogComponent } from '@app-shared/components/confirm-edit-phone-number-dialog/confirm-edit-phone-number-dialog.component';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { apisDataCacheKeys } from '@app-constants/app.constants';
declare var $:any;
@Component({
  selector: 'app-editprofile',
  templateUrl: './editprofile.component.html',
  styleUrls: ['./editprofile.component.css']
})

export class EditProfileComponent implements OnInit, OnDestroy {
  ngAfterViewInit(){
    $('body').addClass('edit-profile');
    //$('body').removeClass('inner-header');
  }
  ngOnDestroy(){
    $('body').removeClass('edit-profile');
  }
  userForm!: FormGroup;
  user!: User;
  files: string[] = [];
  profileImageUrl = '';
  userId: any;
  profilePhoto: any;
  pass_key: any;
  personalDetailsChanged: boolean = false;
  constructor(
    private userService: UserService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    public router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private testListService: TestlistService,
    private cd: ChangeDetectorRef,
    private _eventService: EventHandlingService,
    private dialogRef: MatDialogRef<EditProfileComponent>,
    private spinner: NgxSpinnerService, 
  ) {
    this.userId = Number(this.activatedRoute.snapshot.params.id);
    // this.createUserForm();
    this.pass_key = this.authService.pass_key.subscribe(pk => this.pass_key = pk)
    console.log(localStorage.getItem('pass_key'), this.pass_key)
    this.userForm?.get('password')?.patchValue(this.pass_key);
  }

  // @ViewChild('fileInput')
  // el!: ElementRef;
  // imageUrl: any = "https://i.ibb.co/fDWsn3G/buck.jpg";
  // editFile: boolean = true;
  // removeUpload: boolean = false;

  ngOnInit(): void {
    // this.createUserForm();
    if (this.userId) {
      this.createUserForm();
      this.loadUser();
    } else {
    }
  }

  createUserForm(): any {
    this.userForm = this.formBuilder.group({
      board: this.formBuilder.group({
        name: [''],
        image: [''],
        description: [''],
        boardId: [''],
      }),
      email: ['', [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      firstName: ['', [Validators.required]],
      grade: this.formBuilder.group({
        description: [''],
        name: [''],
        gradeId: ['']
      }),
      stream: [''],
      isdCode: [''],
      lastLoggedInTime: [''],
      lastName: ['', [Validators.required]],
      password: [''],
      phone: [null, [Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      profilePhoto: [''],
      isProfileComplete: [false],
      exams: this.formBuilder.array([]),
      country: [''],
      //userName: [''],
      userType: this.formBuilder.group({
        name: [''],
        userTypeId: [''],
      }),
      whatsappConsent: [true],
      userId: ['']
    });
  }

  loadUser(): void {
    this.userService.loadUserDetails().subscribe((data) => {
      this.user = data;
      this.setUserForm();
    });
  }

  setUserForm(): void {
    this.userForm = this.formBuilder.group({
      board: this.user.board ? this.setBoard(this.user.board ? this.user.board : {}) : null,
      email: [this.user.email, [Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
      firstName: [this.user.firstName, [Validators.required]],
      grade: this.user.grade ? this.setGrade(this.user.grade ? this.user.grade : {}) : null,
      stream: [this.user.stream?this.user.stream.streamId:''],
      isdCode: [this.user.isdCode],
      lastLoggedInTime: [this.user.lastLoggedInTime],
      lastName: [this.user.lastName, [Validators.required]],
      password: [this.user.password],
      phone: [this.user.phone, [Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      profilePhoto: [this.user.profilePhoto],
      isProfileComplete: [this.user.isProfileComplete],
      exams: this.setTargetExams(this.user.exams ? this.user.exams : []),
      country: [this.user.country],
      //userName: [this.user.userName],
      userType: this.user.userType ? this.setUserType(this.user.userType ? this.user.userType : {}) : null,
      whatsappConsent: [this.user.whatsappConsent],
      userId: [this.user.userId]
    });
  }

  setBoard(board: any): any {
    return this.formBuilder.group({
      name: [board.name],
      image: [board.image],
      description: [board.description],
      boardId: [board.boardId]
    });
  }

  setGrade(grade: any): any {
    return this.formBuilder.group({
      description: [grade.description],
      name: [grade.name],
      gradeId: [grade.gradeId]
    });
  }

  createTargetExams(value: any): any {
    return this.formBuilder.group({
      description: value.description,
      image: value.image,
      examId: value.examId,
      name: value.name,
    });
  }

  setTargetExams(x: any): any {
    const arr = new FormArray([]);
    x.forEach((y: any) => {
      arr.push(this.formBuilder.group({
        description: y.description,
        image: y.image,
        examId: y.examId,
        name: y.name,
      }));
    });
    return arr;
  }

  setUserType(userType: any): any {
    return this.formBuilder.group({
      userTypeId: [userType.userTypeId],
      name: [userType.name]
    });
  }

  get u() { return this.userForm.controls; }

  getFileName(photo: any): void {
    const photoUrl = photo
    // const pathname = new URL(url).pathname;
    const index = photoUrl?.lastIndexOf('/');
    const sub = (-1 !== index) ? photoUrl.substring(index + 1) : photoUrl;
    return sub;
  }

  showMyProfile(): void {
    this.router.navigate(['myprofile']);
  }

  onFileChanged(event: any, imageName: string): void {

    const imageFile = event.target.files[0];
    if (imageFile) {
      //console.log(imageFile, 'imageFile');

      var max_filesize_mb:any=1;
      var max_filesize_kb=1024*max_filesize_mb;
      var file_size_error=false;
      var file_type_error=false;

      var file_size_in_kb=(imageFile.size/1024);
      var file_type= imageFile.type;

      if(file_size_in_kb>max_filesize_kb){
        file_size_error=true;
      }

      var allowed_file_types=[
      'image/jpeg',
      'image/jpg',
      'image/png',
      ];
      if(!allowed_file_types.includes(file_type)){
          file_type_error=true;
      }

      if(file_size_error==true || file_type_error==true){
        var error_message='';
        if(file_size_error==true && file_type_error==true){
            error_message="Please upload only JPG/JPEG/PNG files of max size "+max_filesize_mb+"Mb";
        }else if(file_size_error==true && file_type_error==false){
            error_message="File size should not be more than "+max_filesize_mb+"Mb";
        }else{
            error_message="Please upload only JPG/JPEG/PNG files";
        }
        this.resetFile($('#profileImageInput'));
        window.alert(error_message);

      } else {
        this.files = [];
        for (let i = 0; i < event.target.files.length; i++) {
          switch (imageName) {
            case 'profileImage': this.readerOnload(event, imageName, i); break;
            default: break;
          }
          const file = event.target.files[i];
          // this.files.push({ data: file });
          this.files.push(file);
          console.log(this.files)
        }
        event.target.value = ''
      }

    }



  }

  readerOnload(event: any, imageName: any, i: number): any {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      switch (imageName) {
        case 'profileImage': this.profileImageUrl = event.target.result; break;
        default: break;
      }
    };
    reader.readAsDataURL(event.target.files[i]);
    return reader;
  }

  onUpload(imageName: string): void {
    for (let i = 0; i < this.files.length; i++) {
      const file = this.files[i];
      const formData = new FormData();
      formData.append('file', file);
      this.checkNameAndStoreImageUrl(imageName, formData);
    }
  }

  checkNameAndStoreImageUrl(imageName: string, formData: FormData): any {
    this.userService.uploadImage(this.userId, formData).subscribe((data: any) => {
      console.log(data);
      if (data) {
        switch (imageName) {
          case 'profileImage': localStorage.setItem('profileImageUrl', data.photoUrl);
            this.authService.setPhoto(data.photoUrl)
            this.userForm.get('profilePhoto')?.patchValue(data.photoUrl);
            break;
          default: break;
        }
      }
    },
      (err: any) => {                                     // on error
        console.log(err)
      });
  }

  confirmDeletePhoto(): void {
    const config: MatDialogConfig = {
      width: '487px',
      data: { message: `Delete Profile Image?`, message2: `Are you sure you want to delete your profile image` }
    };
    const dialogRef = this.dialog.open(ConfirmDeleteImageDialogComponent, config);
    dialogRef.afterClosed().subscribe((isConfirmed) => {
      if (isConfirmed === true) {
        this.deleteProfilePhoto();
      }
    });
  }

  deleteProfilePhoto(): void {
    const fileName = this.getFileName(this.userForm.value.profilePhoto)
    this.userService.deleteImage(fileName, this.userId).subscribe((data: any) => {
      console.log(data);
      // TO DO API
      // this.authService.setPhoto(data.photoUrl)
      // this.profileImageUrl = 'assets/img/empty-profile.svg'
      // this.userForm.get('profilePhoto')?.patchValue(null);
      this.authService.setPhoto(null)
      this.profileImageUrl = 'assets/img/empty-profile.svg'
      const currentData = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
      currentData.profilePhoto = null;
      localStorage.setItem(apisDataCacheKeys.userDetails, JSON.stringify(currentData));
      this.userForm.get('profilePhoto')?.setValue(null);
    },
      (error: any) => {                                     // on error
        console.log(error);
      });
  }

  setDefaultPic() {
    this.profilePhoto = 'assets/img/empty-profile.svg';
  }

  editSelectedGrade(): void {
    const config: MatDialogConfig = {
      width: '570px',
      data: { 
        isGradeEdit: true,
        grade: this.userForm.value.grade,
        selectedStream:(this.userForm.value.stream!='')?this.userForm.value.stream:''
      }
    };
    const dialogRef = this.dialog.open(GradesdialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        console.log('edit grade value', value)
        this.updateGrade(value.grade);
        this.updateStream(value.stream?.streamId);
        this.testListService.clearApisData(apisDataCacheKeys.allTests);
        this.testListService.clearApisData(apisDataCacheKeys.attemptedTests);
      }
    });
  }

  updateGrade(value: any): void {
    this.userForm.get('grade')?.patchValue(value);
  }
  updateStream(value: any): void {
    this.userForm.get('stream')?.patchValue(value);
  }

  editSelectedBoard(): void {
    const config: MatDialogConfig = {
      width: '570px',
      //height: '536px',
      panelClass: 'edit-board',
      data: {
        message: 'What board are you enrolled in?',
        message2: `If you can’t find it in the list, enter in the search box`,
        isBoardEdit: true,
        board: this.userForm.value.board,
      }
    };
    const dialogRef = this.dialog.open(BoardsDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        console.log('edit board value', value)
        this.updateBoard(value);
      }
    });
  }

  updateBoard(value: any): void {
    this.userForm.get('board')?.patchValue(value);
  }

  // Edit target exams

  editSelectedTargetExam(): void {
    const config: MatDialogConfig = {
      width: '570px',
      //height: '626px',
      panelClass:'edit-target-exam',
      data: {
        message: 'What exams are you targeting?',
        message2: `Select as many. If you can’t find it in the list, enter in the search box`,
        isExamEdit: true,
        exams: this.userForm.value.exams
      }
    };
    const dialogRef = this.dialog.open(ExamDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        console.log('edit exams value', value)
        this.updateTargetExam(value);
      }
    });
  }

  updateTargetExam(value: any): void {
    this.deleteTargetExam();
    this.addTargetExam(value);
  }

  deleteTargetExam(): void {
    const control = (this.userForm.controls['exams'] as FormArray)
    while (control.length !== 0) {
      control.removeAt(0)
    }
  }

  addTargetExam(value: any) {
    const currentTargetExam = localStorage.getItem("targetExamName");
    let changeTargetExam = true;
    for (let i = 0, len = value.length; i < len; i++) {
      (this.userForm.get('exams') as FormArray).insert(i, this.createTargetExams(value[i]));
      if(value[i].name?.replaceAll(" ", "")?.toUpperCase() == currentTargetExam) {
        changeTargetExam = false;
      }
    }
    if(changeTargetExam) {
      localStorage.setItem("targetExamName", value[0].name?.replaceAll(" ", "")?.toUpperCase());
    }
  }

  get targetExam(): any { return this.userForm.get('exams') as FormArray }

  // Edit phone number

  editPhoneNumber(): void {
    const config: MatDialogConfig = {
      width: '487px',
      height: '295px',
      data: {
        message: 'Edit Phone Number',
        phone: this.userForm.value.phone,
        isdCode: this.userForm.value.isdCode,
        firstName: this.userForm.value.firstName,
        lastName: this.userForm.value.lastName,
        whatsappConsent: this.userForm.value.whatsappConsent,
        userObject: this.userForm.value
      }
    };
    const dialogRef = this.dialog.open(EditPhoneNumberDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        console.log('edit phn value', value)
        // this.loadUser()
        this.userForm?.get('phone')?.patchValue(value);
        const currentData = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
        currentData.phone = value;
        localStorage.setItem(apisDataCacheKeys.userDetails, JSON.stringify(currentData));
      }
    });
  }

  // Change password

  editPassword(): void {
    if(this.user['isPassSet']) {
      const config = {
        width: '570px',
        data: { message: 'Change password',
        userObject: this.userForm.value  }
      };
      const dialogRef1 = this.dialog.open(ChangePasswordDialogComponent, config);
      dialogRef1.afterClosed().subscribe((value) => {
        if (value) {
          console.log('edit pwd value', value)
          this.userForm?.get('password')?.patchValue(value);
        }
      });
    } else {
      const config = {
      width: '570px',
      // height: '550px',
      data: {
        message: 'Change password',
        password: this.userForm.value.password,
        userObject: this.userForm.value
      }
    };
      const dialogRef = this.dialog.open(ChangePasswordViaOtpDialogComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        console.log('edit pwd value', value)
        this.userForm?.get('password')?.patchValue(value);
        // this.loadUser()
      }
    });
    }
  }
  changePersonalDetails($event, fieldName: any) {
    const currentData = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    const currentVal = currentData[fieldName] || '';
    const newVal = $event.target?.value || '';
    this.personalDetailsChanged = currentVal != newVal;
  }
  confirmSave() {
    this.userForm.markAllAsTouched();
    if (!this.userForm.valid)  return;
    updateUser.call(this, [
      {name: 'firstName', value: this.userForm.value.firstName},
      {name: 'lastName', value: this.userForm.value.lastName},
      {name: 'email', value: this.userForm.value.email},
    ], () => {successOpen.call(this, 'Profile Updated', `Your profile has been updated  successfully`, () => this.dialog.closeAll())});
  }
  resetFile(e:any) {
    e.wrap('<form>').closest('form').get(0).reset();
    e.unwrap();
  }
}

export function successOpen(message: any, message2: any, cb: any) {
  const config: MatDialogConfig = {
    width: '487px',
    height: '292px',
    data: { message: message || 'Profile Updated', message2: message2 || `Your profile has been updated  successfully` }
  };
  const dialogRef = this.dialog.open(ConfirmEditPhoneNumberDialogComponent, config);
  dialogRef.afterClosed().subscribe((value) => {
    if (value === true) {
      cb && cb();
      
    }
  });
}

export function updateUser(filedsToUpdate: any, cb: any): void {
  
  
    // let userFormData = {
    //   ...this.userForm.value,
    //   stream:(this.userForm.value.stream!=null && this.userForm.value.stream!='')?{streamId:this.userForm.value.stream}:null
    // }
    const currentData = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    filedsToUpdate.forEach(element => {
     currentData[element.name] = element.value;
    });
    //const obj = JSON.parse(JSON.stringify(userFormData));
    const obj = currentData;
    console.log('updated user data', JSON.stringify(obj))
    obj.active = true;
    this.spinner.show();
    this.userService.updateUserDetails(obj).subscribe((data: any) => {
      //this.successOpen();
      
        // alert('User details updated successfully');
        //console.log(data.userDto,'datafrom serrver');
        this.personalDetailsChanged = false;
        let gradeByName = data?.userDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
        localStorage.setItem('studentid', obj.phone);
        this.userService.setMobileAndName({phone: data.userDto.phone, isdCode: data.userDto.isdCode, firstName: data.userDto.firstName, lastName: data.userDto.lastName,
          whatsappConsent: data.userDto.whatsappConsent, userId: data.userDto.userId,profilePhoto:data.userDto.profilePhoto, grade: Number(gradeByName)});
        if (data.accessToken) {
          localStorage.setItem('token', data.accessToken);
          let _headers = {
            accesstoken: data.accessToken,
            studentid: obj.phone,
            // 'methodtype': 'RULES'
          };
        }
        
        this.userService.updateRequestedUserData(data.userDto);
        //this._eventService.changeAction({ type: 'updateProPic'});
        
        this.spinner.hide();
        cb();
    },
      (error: any) => {                                     // on error
        alert(error.error.message);
        this.spinner.hide();
      });
  
}
